<script>
  import Page from '@components/page'
  import Form from '@components/forms'
  import FileUpload from '@components/inputs/file-upload.svelte'
  import Button from '@components/buttons/button.svelte'
  import { useForm, router } from '@inertiajs/svelte'
  import { Save, ChevronLeft, Globe } from 'lucide-svelte'

  let { live_session } = $props()

  let cover_image = $state(null)

  $effect(() => {
    cover_image = live_session?.cover_image || null
  })

  const form = useForm({
    color: live_session?.color || '',
    description: live_session?.description?.html || '',
    tag_ids: live_session?.tag_ids || [],
  })

  function handleSubmit(e) {
    e.preventDefault()
    $form.transform(data => ({
      live_session: { color: data.color, description: data.description, tag_ids: data.tag_ids },
      cover_image: cover_image?._new ? cover_image.file : undefined,
      purge_cover_image: !cover_image ? true : undefined,
    }))
    $form.patch(`/admin/live_sessions/${live_session.id}`, {
      onSuccess: () => router.visit('/admin/live_sessions'),
    })
  }

  let navigationProps = {
    title: live_session?.name || "Edit live session",
    links: [{ text: "Admin", href: "/admin" }, { text: "Live Sessions", href: "/admin/live_sessions" }],
  }
</script>

<Page.Layout title={live_session?.name || "Edit live session"}>

  <Page.Navigation {...navigationProps} />

  <Page.Titles title={live_session?.name || "Edit live session"} subtitle="Edit this live session">
    {#snippet buttons()}
      <Button text="Back" path="/admin/live_sessions" BeforeIcon={ChevronLeft} />
      <Button type="submit" form="live-session-form" text="Update" variant="submit" Icon={Save} loading={$form.processing} />
      <Button path={`/live-sessions/${live_session.id}`} Icon={Globe} hint="View live session" />
    {/snippet}
  </Page.Titles>

  <Form.Element {form} id="live-session-form" onsubmit={handleSubmit}>
    <Page.Content class="gap-6 xl:flex-row xl:items-start">

      <main class="xl:w-[66%] flex flex-col gap-6">

        <Form.Fieldset label="Description">
          <Form.Item name="description" type="richtext" bind:value={$form.description} hint="Leave blank to use the description synced from Arlo" />
        </Form.Fieldset>

        <Form.Fieldset label="Cover image">
          <FileUpload files={cover_image ? [cover_image] : []} onChange={files => cover_image = files[0] || null} maxCount={1} showInputIfFull={false} />
        </Form.Fieldset>
        
      </main>

      <aside class="xl:w-[31%] flex flex-col gap-6">
        <Form.Fieldset label="Details">
          <Form.Items>
            <Form.Item name="color" label="Color" type="color" bind:value={$form.color} cols={12} />
          </Form.Items>
        </Form.Fieldset>

        <Form.Fieldset label="Tags">
          <Form.Item name="tag_ids" type="autocomplete" multiple bind:value={$form.tag_ids} url="api/v1/tags" loadAll labelKey="name" valueKey="id" placeholder="Search tags…" />
        </Form.Fieldset>
      </aside>

    </Page.Content>
  </Form.Element>

</Page.Layout>
